import { Injectable } from '@angular/core';
import {
  NameFilter,
  CompanyService,
  CommunicationManagerService,
  MonthlyOverview,
  MonthlyBalance,
  QuarterlyBalance,
  LocalStorageService,
  SessionManagerService,
  FiscalYearService,
} from '@ops/shared-types';
import { Observable, combineLatest, lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  selectedCompany$: Observable<NameFilter>;


  constructor(
    private companyService: CompanyService,
    private cm: CommunicationManagerService,
    private ls: LocalStorageService,
    private sessionManager: SessionManagerService,
    private fiscalYearService: FiscalYearService
  ) {
    this.selectedCompany$ = this.companyService.selectedCompany$.asObservable();
  }

  public async createNewProject() {
    this.cm.post('project');
  }

  getCompanies() {
    return this.companyService.getCompanyFilters();
  }

  getMonthlyOverviewData(companyId: string) {
    return combineLatest([
      this.getMonthlyBalance(companyId),
      this.getMonthlyOverview(companyId),
    ]).pipe(
      map(([monthlyBalance, monthlyOverview]) => ({
        monthlyBalance: monthlyBalance.sort(
          (a, b) =>
            new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        ),
        monthlyOverview,
      }))
    );
  }

  getMonthlyOverview(companyId: string) {
    return this.cm.get('company/overview/monthly', [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<MonthlyOverview>;
  }

  getMonthlyBalance(companyId: string) {
    return this.cm.get(`monthlyAccountBalance/all`, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<MonthlyBalance[]>;
  }

  getQuarterlyBalance(companyId: string) {
    return this.cm.get('company/overview/quarterly', [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<QuarterlyBalance>;
  }

  selectCompany(companyFilter: NameFilter) {
    this.ls.setCurrentCompany(companyFilter);
    this.sessionManager.setCurrentCompany(companyFilter._id);
    this.companyService.selectedCompany$.next(companyFilter);

    if(this.ls.getFiscalYearsForCompany().length) {
      return;
    }

    let fiscalYearList = [];

    if (this.fiscalYearService && typeof this.fiscalYearService.getFiscalYearsForCompany === 'function') {
      lastValueFrom(this.fiscalYearService.getFiscalYearsForCompany(companyFilter._id)).then(
        fiscalYears => {
          fiscalYearList = fiscalYears || [];
          this.ls.setFiscalYearsForCompany(fiscalYears);

        },
        error => {
          fiscalYearList = [];
          console.error('Error getting fiscal years for company', error);
        }
      );
    }
  }
}
